import { makeStyles, Snackbar } from "@material-ui/core";
import React from "react";
import PropTypes from "prop-types";

//style
const useStyles = makeStyles(() => ({
    copySectionSnackbarContent: {
        justifyContent: "center",
        fontSize: "14px",
        minWidth: "160px",
    },
}));

export const WithCopyToClipboard = (WrappedComponent) => {
    const Component = ({ textToCopy, copiedSuccessMessage, ...props }) => {
        const classes = useStyles();

        const [snackBarState, setBarState] = React.useState({
            open: false,
            key: null,
        });

        const handleCopyToClipboard = () => {
            setBarState({ open: true, key: Date.now() });
            navigator.clipboard.writeText(textToCopy);
        };

        const handleClose = (_, reason) => {
            if (reason === "clickaway") return;

            setBarState({ open: false, key: null });
        };

        return (
            <>
                <WrappedComponent {...props} handleCopyToClipboard={handleCopyToClipboard} />
                <Snackbar
                    {...snackBarState}
                    autoHideDuration={2000}
                    onClose={handleClose}
                    message={copiedSuccessMessage || "Copied to clipboard"}
                    ContentProps={{
                        classes: { root: classes.copySectionSnackbarContent },
                    }}
                />
            </>
        );
    };

    Component.propTypes = {
        textToCopy: PropTypes.string.isRequired,
        copiedSuccessMessage: PropTypes.string,
    };

    return Component;
};
